import { Seo } from "../components/Seo";
import { Reveal, Eyebrow } from "../components/Reveal";
import RetailFocus from "../components/sections/RetailFocus";
import CtaBand from "../components/sections/CtaBand";
import { INDUSTRIES_SERVED } from "../lib/data";
import { ArrowUpRight } from "lucide-react";

const Industries = () => (
  <main data-testid="industries-page">
    <Seo
      title="Who We Serve | Petroleum Retailers, Gas Stations & Car Washes | Petroline Services"
      description="Petroline Services supports branded and independent gas stations, convenience stores, car-wash operators, petroleum retailers and commercial property managers across Southern Ontario."
    />

    <section className="mx-auto max-w-7xl px-5 pb-16 pt-24 lg:px-8 lg:pt-32">
      <Reveal>
        <Eyebrow>Industries</Eyebrow>
        <h1 className="max-w-3xl font-display text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl lg:text-6xl">
          Built for the Businesses Behind <span className="text-ember">the Pumps</span>
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-mist md:text-lg">
          Petroleum retail is a demanding environment: high traffic, long hours and properties
          that combine retail, mechanical and customer-facing space. Our services are designed
          for the operators who run them.
        </p>
      </Reveal>
    </section>

    <section className="border-t border-black/10 bg-ink-surface">
      <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-28">
        <div className="grid gap-px border border-black/10 bg-black/10 sm:grid-cols-2 lg:grid-cols-4">
          {INDUSTRIES_SERVED.map((industry, i) => (
            <Reveal key={industry} delay={(i % 4) * 0.07} className="h-full">
              <div
                data-testid={`industry-card-${industry.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group flex h-full flex-col justify-between bg-white p-7 transition-colors duration-300 hover:bg-ink"
              >
                <span className="font-display text-xs font-bold text-black/30">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="mt-10 flex items-start justify-between gap-4">
                  <h2 className="font-display text-lg font-bold leading-snug tracking-tight">
                    {industry}
                  </h2>
                  <ArrowUpRight className="h-5 w-5 shrink-0 text-ember opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <RetailFocus />
    <CtaBand title="Manage a petroleum retail property?" subtitle="Contact us to discuss your facility's repair, renovation and maintenance requirements." />
  </main>
);

export default Industries;
